import React, { useEffect, useState } from 'react';
import emailjs from 'emailjs-com';
import '../css/confirmacao.css';
import '../css/components.css';
import logo from '../images/logo.png';
import Modal from '../components/ModalConfirmação';

const ConfirmacaoPresenca = () => {
  const [showScroll, setShowScroll] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [modalTitle, setModalTitle] = useState('');
  const [modalMessage, setModalMessage] = useState('');

  const handleScroll = () => {
    setShowScroll(window.scrollY > 300);
  };

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const [nome, setNome] = useState('');
  const [levaAcompanhante, setLevaAcompanhante] = useState(false);
  const [nomeAcompanhante, setNomeAcompanhante] = useState('');

  const openModal = (title, message) => {
    setModalTitle(title);
    setModalMessage(message);
    setShowModal(true);
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const currentDate = new Date();
    const deadline = new Date('2026-04-1  0T23:59:59');

    if (currentDate > deadline) {
      openModal("Prazo Expirado", "Desculpe, o prazo de confirmação expirou.");
      return;
    }

    if (!nome) {
      openModal("Campo Obrigatório", "Por favor, insira seu nome.");
      return;
    }

    const templateParams = {
      nome: nome,
      levaAcompanhante: levaAcompanhante ? "Sim" : "Não",
      nomeAcompanhante: levaAcompanhante ? nomeAcompanhante : "Nenhum acompanhante",
      to_email: "susanrigo@gmail.com",
    };

    emailjs.send('service_42bjl8s', 'template_a3t2307', templateParams, 'GRZvHGzmU-6EZ85z4').then(
      () => {
        openModal("Confirmação Enviada", "Sua confirmação foi enviada com sucesso!");
      },
      () => {
        openModal("Erro", "Ocorreu um erro ao enviar sua confirmação.");
      }
    );
  };

  return (
    <div className="wedding-page">
      <Modal
        show={showModal}
        onClose={() => setShowModal(false)}
        title={modalTitle}
      >
        <p>{modalMessage}</p>
      </Modal>

      <div className="banner-container">
        <div className="banner"></div>
        <div className="logo-container">
          <img src={logo} alt="Logo" className="logo" />
        </div>
        <div className="banner"></div>
      </div>

      <section className="rsvp-section">
        <h2 className="rsvp-title">Confirmação de Presença</h2>
        <p className="text-description">Por favor, confirme a sua presença para nossa cerimônia, até a data limite do dia 30 de abril de 2026.</p>
        <br />

        <form onSubmit={handleSubmit} className="rsvp-form">
          <div className="form-field">
            <label htmlFor="nome" className="form-label">Seu Nome:</label>
            <input
              type="text"
              id="nome"
              className="form-input"
              value={nome}
              onChange={(e) => setNome(e.target.value)}
              required
            />
          </div>

          <div className="form-field">
            <label htmlFor="levaAcompanhante" className="form-label">Possui cônjuge?</label>
            <input
              type="checkbox"
              id="levaAcompanhante"
              className="form-checkbox"
              checked={levaAcompanhante}
              onChange={(e) => setLevaAcompanhante(e.target.checked)}
            />
          </div>

          {levaAcompanhante && (
            <div className="form-field">
              <label htmlFor="nomeAcompanhante" className="form-label">Nome do Acompanhante:</label>
              <input
                type="text"
                id="nomeAcompanhante"
                className="form-input"
                value={nomeAcompanhante}
                onChange={(e) => setNomeAcompanhante(e.target.value)}
                required
              />
            </div>
          )}

          <button type="submit" className="submit-button">Enviar Confirmação</button>
        </form>
      </section>
    </div>
  );
};

export default ConfirmacaoPresenca;